<template>
  <div :class="['button-cluster', {'below-item':belowItem},{'top-center':topCenter},{'bottom-center':bottomCenter},{'bottom-left':bottomLeft},{'ui-hidden':hideGlobalUI}]">
    <slot/>
    <template
      v-for="(btn,i) in buttons"
    >
  
      <draggable v-if="btn.dragOptions"
        v-model="btn.dragModel"
        :options="btn.dragOptions"
        @start="btn.dragStartAction"
        @end="btn.dragEndAction"
        @move="btn.dragEndAction"
        @change="btn.dragChangeAction"
      >
          <button
            v-if="conditionalValue(btn)"
            :class="buttonClass(btn)"
            @click="btn.clickHandler(item, $event)"
            :title="btn.iconOnly ? btn.title : ''"
            :key="i"
          >
            <i v-if="btn.icon" :class="['material-icons', btnSize, {'left':!btn.iconOnly}]">{{ btn.icon }}</i>
            <template v-if="!btn.iconOnly">{{ btn.title }}</template>
          </button>
      </draggable>
      <button v-else-if="conditionalValue(btn)"
        :class="buttonClass(btn)"
        @click="btn.clickHandler(item, $event)"
        :title="btn.iconOnly ? btn.title : ''"
        :key="i"
      >
        <i v-if="btn.icon" :class="['material-icons', btnSize, {'left':!btn.iconOnly}]">{{ btn.icon }}</i>
        <template v-if="!btn.iconOnly">{{ btn.title }}</template>
      </button>
      
    </template>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

import { mapState } from 'vuex'

export default {

  name: 'ButtonCluster',
  components : {draggable},
  props : {
    'buttons' : {
      type: Array,
      required:true,
      default: {}
    },
    'item' : {
      type:Object,
      required:false,
      default: () => {
        return {}
      }
    },
    belowItem : {
      type : Boolean,
      default : false
    },
    topCenter : {
      type : Boolean,
      default : false
    },
    bottomCenter : {
      type : Boolean,
      default : false
    },
    bottomLeft : {
      type : Boolean,
      default : false
    },
    highlight : {
      type : String,
      default : 'green'
    },
    btnSize : {
      type : String,
      default : 'md-18'
    }
  },

  methods:  {
    buttonClass(btn) {
      let classes = ['btn', `btn-${btn.icon}`]
      if( typeof btn.class !== "undefined" ) {
        classes.push(btn.class)
      }
      if( this.highlight ) {
        classes.push(`btn-color-${this.highlight}`)
      }

      return classes.join(' ');
    },
    conditionalValue(btn) {
      return btn.conditional? btn.conditional(): true;
    }
  },

  computed : {
    ...mapState(['hideGlobalUI'])
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
.button-cluster-parent {
  &:hover {
    > .button-cluster {
      display:flex;
    }
  }
}

.button-cluster {
  $height:30px;
  $padding:4px;
  display:none;
  bottom:0;
  padding:$padding;
  right:0;
  left:auto;
  z-index:1000;
  // font-size:12px;
  &.ui-hidden {
    display:none !important;
  }

  $bottom:$height + $padding;
  &.below-item {
    bottom:-$bottom;    
  }
  &.top-center {
    top:-$height/4;
    bottom:auto;
    right:auto;
    left:50%;
    transform:translateX(-50%);
  }
  &.bottom-center {
    bottom:-$height/4;
    top:auto;
    right:auto;
    left:50%;
    transform:translateX(-50%);
  }
  &.bottom-left {
    bottom:-$height/4;
    top:auto;
    right:auto;
    left:0;
    // transform:translateX(-50%);
  }
  button {
    transition:all .5s ease !important;
    height:$height;
    background-color:#37c120;
    color:white;
    justify-content:center;
    &:focus, &:active {
      outline:0;
    }

    .material-icons {
      // font-size:18px;
    }
    &:hover {
      background-color:darken(#37c120,8%);
    }
    &:not(:last-child) {
      border-right:1px solid rgba(white, .7);
    }

    &.btn-color-blue {
      background-color:#27b9f1;
      &:hover {
        background-color:darken(#27b9f1,8%);
      }
    }
    &.btn-color-pink {
      background-color:#f127a0;
      &:hover {
        background-color:darken(#f127a0,8%);
      }
    }
    &.btn-color-orange {
      background-color:#f16a0a;
      &:hover {
        background-color:darken(#f16a0a,8%);
      }
    }
    &.btn-color-navy {
      background-color:#1b3dbf;
      &:hover {
        background-color:darken(#1b3dbf,8%);
      }
    }
    &.delete-confirmation {
      $val : 45%;
      $bg : darken(white,7%);
      color:lighten(red, 5%);
      background-color:lighten($bg, 5%);
      &:hover {
        background-color:lighten($bg, 5%);
        color:black;
      }
    }
    &.btn-delete-gray {
      $val : 45%;
      $bg : darken(white,7%);
      background-color:$bg;
      color:darken(white, $val);
      // color:white;
      &:hover {
        color:lighten(red, 5%);
        background-color:lighten($bg, 5%);
      }
    }
  }

  &.addon-dragging {
    .delete-item-btn {
      background-color:red;
      width:100px;
    }
  }  
} // .button-cluster

</style>


// WEBPACK FOOTER //
// src/components/UI/ButtonCluster.vue